export default "__VITE_ASSET__dMlttM54__"